import qs from 'qs'
export const getUrlValues = () => {
  const index = window.location.href.lastIndexOf('?')
  return qs.parse(window.location.href.slice(index + 1))
}